import { CurrencyInfoBlock } from './CurrencyInfoTable/CurrencyInfo';
import { CurrencyTab } from './CurrencyTabs';
import { TransactionTableView } from './TransactionTable';
import { TransactionInfoBlock } from './TransactionInfo';
import styles from './index.module.scss';

export const TransactionsPage = () => {
  return (
    <>
      <div className='container'>
        <CurrencyTab />
      </div>
      <div className={styles.wrapper}>
        <TransactionInfoBlock />
        <CurrencyInfoBlock />
        <TransactionTableView />
      </div>
    </>
  );
};

export default TransactionsPage;
